var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "app-main-content",
      staticStyle: {
        "flex-grow": "1",
        display: "flex",
        "flex-direction": "column"
      },
      attrs: {
        id: "baisc-config",
        "element-loading-text": "",
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-tab",
          staticStyle: {
            "flex-grow": "1",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_TemplateManagement"),
                    name: "templateManagement"
                  }
                },
                [_c("template-management")],
                1
              ),
              _vm.isAdmin
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_TemplateTypeManagement"),
                        name: "templateTypeManagement"
                      }
                    },
                    [_c("template-type-management")],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ConfigurationManagement"),
                    name: "configurationManagement"
                  }
                },
                [_c("configuration-management")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_MappingManagement"),
                    name: "mappingManagement"
                  }
                },
                [_c("mapping-management")],
                1
              ),
              _vm.isSysAdmin
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t(
                          "CargoMsg.Cargo_InitializeTemplateManagement"
                        ),
                        name: "tabInitTemplateManage"
                      }
                    },
                    [_c("init-template-manage")],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_BusinessStatusManagement"),
                    name: "businessStatusManagement"
                  }
                },
                [
                  _c("tenant-business-status-management", {
                    ref: "businessStatusManagement"
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_TriggerTypeManagement"),
                    name: "triggerTypeManagement"
                  }
                },
                [_c("trigger-type-management")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_FileTypeManagement"),
                    name: "documentTypeManagement"
                  }
                },
                [_c("document-type-management")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_DefaultValueManagement"),
                    name: "defaultManagement"
                  }
                },
                [_c("default-management")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ValidationRuleConfiguration"),
                    name: "checkRuleConf"
                  }
                },
                [_c("check-rule-conf")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_EDITemplateSettings"),
                    name: "EDITemplateSettings"
                  }
                },
                [_c("edi-template-settings")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_WarnRuleConfiguration"),
                    name: "warnRuleConfiguration"
                  }
                },
                [_c("warn-rule-configuration")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_OnlineShippingOrderSettings"),
                    name: "settingUpOfShippingOnlineCounter"
                  }
                },
                [_c("setting-up-of-shipping-online-counter")],
                1
              ),
              _vm.isAutomaticFeeToSubJob
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t(
                          "CargoMsg.Cargo_ChargeAutomaticAllocationConfig"
                        ),
                        name: "automaticAllocationConfig"
                      }
                    },
                    [_c("automatic-allocation-config")],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_BPMApprovalProcess"),
                    name: "bpmApprovalProcess"
                  }
                },
                [
                  _vm.isPlatform
                    ? _c("div", [_c("bpm-approval-process-advance-setting")], 1)
                    : _c("div", [_c("bpm-approval-process")], 1)
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_PushServiceConfiguration"),
                    name: "pushConfiguration"
                  }
                },
                [_c("push-configuration")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_CustomInvoiceRemarks"),
                    name: "diyInvoiceRemark"
                  }
                },
                [_c("diy-invoice-remark")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_EmailTemplateManagement"),
                    name: "MailBoxManagement"
                  }
                },
                [_c("mail-box-management")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_BillOfLadingConfiguration"),
                    name: "putASingleRule"
                  }
                },
                [_c("put-a-single-rule")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Financial_Archiving_Settings"),
                    name: "financialArchivingSettings"
                  }
                },
                [_c("financial-archiving-settings")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("SeaExport.DocumentRecognitionSettings"),
                    name: "ocrRecordSet"
                  }
                },
                [_c("ocr-record-set")],
                1
              ),
              _vm.isPlatform
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.CARGO_RECOGNITION_SETTING"),
                        name: "ocrRecognitionSetting"
                      }
                    },
                    [_c("ocr-recognition-setting")],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ServiceLockSettings"),
                    name: "serviceLockSetting"
                  }
                },
                [_c("service-lock-setting")],
                1
              ),
              _vm.isZY &&
              _vm.$checkPermission([
                "tab_MTConfig_ChinaPostProductConfiguration"
              ])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.ChinaPostProductConfiguration"),
                        name: "ChinaPostProductConfiguration"
                      }
                    },
                    [_c("ChinaPostProductConfiguration")],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.CustomFieldDisplayConfiguration"),
                    name: "CustomFieldDisplayConfiguration"
                  }
                },
                [_c("customFieldDisplayConfiguration")],
                1
              ),
              _vm.isPlatform
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.VASChannelSetting"),
                        name: "VASChannelSetting"
                      }
                    },
                    [_c("VAS-channel-setting")],
                    1
                  )
                : _vm._e(),
              _vm.isPlatform
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.AnalyzeChannelSettings"),
                        name: "AnalyzeChannelSettings"
                      }
                    },
                    [_c("Analyze-channel-settings")],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_BookingChannelConfig"),
                    name: "bookingChannelConfig"
                  }
                },
                [_c("booking-channel-config")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ImperialUnits"),
                    name: "imperialUnits"
                  }
                },
                [_c("imperial-units-setting")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ReleaseNumberConfigTab"),
                    name: "releaseNumberConfig"
                  }
                },
                [_c("release-number-config")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_ProfitShareConfig"),
                    name: "profitShareConfig"
                  }
                },
                [_c("profit-share-config")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: "交叉委托加价规则",
                    name: "crossDelegationMarkupRule"
                  }
                },
                [
                  _c("cross-delegation-markup-rule", {
                    ref: "crossDelegationMarkupRule"
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_InternalFeeMarkupRuleConfig"),
                    name: "internalFeeMarkupRule"
                  }
                },
                [_c("internal-fee-markup-rule")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }